export const listDocumentsService = (fetch) => async () => {
  try {
    const response = await fetch({ url: "/api/v2/lits/documents" });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
